import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../config/reduxIndex';
import { DropTarget } from 'react-dnd';
import { PMDNDTypes, WIN_SIZE_MIN } from "../constants";
import PMDesktopTasks from "./PMDesktopTasks";

class PMDesktop extends Component {
	state = {
		isLoading: false,
		editMode: 'none',
		currentTask: null,
		currentParentTask: null,
		tempTask: null,
		hiddenFields: [
			'uniqueID',
			'leadNotes',
			'expectedHours',
			'actualHours'
		]
	}

	funcRemoveWindow = (index) => {
		//console.log("[PMDesktop] rmv window ", index);
		let newState = Object.assign({}, this.state);
		let tasks = newState.storedTasks;
		tasks[index].hidden = true;
		this.setState({ storedTasks: tasks });
	}

	funcResize = (index, mode) => {
		//console.log("[PMDesktop] resize window ", index);
		let rsz = Object.assign({}, this.state);
		let winrsz = rsz.storedTasks;
		let newSz = (!mode ? WIN_SIZE_MIN : this.state.storedTasks[index].window.og_size_h);

		winrsz[index] = {
			...this.state.storedTasks[index],
			window: this.state.storedTasks[index].window,
		}

		winrsz[index].window.size_h = newSz;
		winrsz[index].window.zIndex = this.state.storedTasks[index].window.zIndex + 2

		this.setState({ storedTasks: winrsz });
	}

	funcMoveZ = (index) => {
		//console.log("[PMDesktop] move up", index);
		let tmp = Object.assign({}, this.state);
		let wins = tmp.storedTasks;
		wins.forEach((w, i) => {
			w.window.zIndex = (wins.length + i);
		});

		wins[index] = {
			...this.state.storedTasks[index],
			window: this.state.storedTasks[index].window,
		}

		wins[index].window.zIndex = (wins.length + 100);

		this.setState(function () {
			return {
				storedTasks: wins
			}
		});
	}

	funcMoveWindow = (index, x, y) => {
		//console.log("[PMDesktop] move window ", index);
		let new_state = Object.assign({}, this.state);
		let wins = new_state.storedTasks;

		const snappedX = Math.round(x / 16) * 16
		const snappedY = Math.round(y / 16) * 16

		wins[index] = {
			...this.state.storedTasks[index],
			window: this.state.storedTasks[index].window,
		}

		wins[index].window.xLeft = snappedX;
		wins[index].window.yTop = snappedY;
		wins[index].window.zIndex = this.state.storedTasks[index].window.zIndex + 1;

		this.setState(function () {
			return {
				storedTasks: wins
			}
		});
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;
		let currentItem = p.reduxData.storedPhases[this.props.reduxData.currentPhase];

		this.setState(function () {
			return {
				isLoading: true,
			}
		});

		this.setState(function () {
			return {
				isLoading: false,
				storedTasks: p.reduxData.storedTasks,
				editMode: p.reduxData.overlayEditType,
				currentItem: currentItem
			}
		});

	}

	render() {
		const { connectDropTarget, hovered } = this.props;
		//const { match } = this.props // Not used yet
		const { isLoading, storedTasks, tempTask, hiddenFields, currentTask, editMode, currentItem } = this.state;
		const startOver = this.startOver;
		const goBack = this.goBack;
		const addNewTask = this.addNewTask;
		const funcMoveZ = this.funcMoveZ;
		const funcResize = this.funcResize;
		const funcRemoveWindow = this.funcRemoveWindow;
		const selectEditTask = this.selectEditTask;

		const pmProps = {
			currentItem,
			isLoading,
			storedTasks,
			tempTask,
			hiddenFields,
			currentTask,
			editMode,
			startOver,
			goBack,
			addNewTask,
			funcMoveZ,
			funcResize,
			funcRemoveWindow,
			selectEditTask
		}

		return connectDropTarget(
			<div className={"PMDesktop" + (hovered === true ? " PMHoverOld" : "")}>
				<PMDesktopTasks
					{...pmProps}
				/>
			</div>
		);
	}

	addNewTask = (obj) => {
		this.props.addTask(obj);
	}

	selectEditTask = (task) => {
		let newTask = JSON.parse(JSON.stringify(task));
		this.props.setAttributeByObj({
			overlayEditType: 'task-edit',
			temp: newTask
		});
		this.props.openOverlay("pmTaskEdit");
	}

	startOver = () => {
		const { setRoute } = this.props;
		setRoute('/projectmanager/');
	}

	goBack = () => {
		const { setRoute } = this.props;
		setRoute('/projectmanager/');
	}

}


const dropSource = {
	drop: function (props, monitor, component) {
		const item = monitor.getItem();
		//console.log(item); // dragging
		//console.log(component); //drop target
		//console.log(monitor);

		//if (monitor.isOver()) {
		//	console.log("monitor.isOver");
		//}

		//const started = monitor.getInitialClientOffset();
		const sub = monitor.getInitialSourceClientOffset();
		const delta = monitor.getDifferenceFromInitialOffset();
		const calc_x = delta.x + (sub.x);
		const calc_y = delta.y + (sub.y);

		component.funcMoveWindow(item.index, calc_x, calc_y);
	},
	//hover: function (props, monitor, component) {
	//	console.log("hovering over background");
	//}
}

function dropCollect(connect, monitor) {
	//console.log("dropCollect");
	return {
		connectDropTarget: connect.dropTarget(),
		hovered: monitor.isOver({ shallow: true })
	}
}


function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		addTaskGroup: (obj) => {
			dispatch(actions.pm.addTaskGroup(obj))
		},
		addTask: (obj) => {
			dispatch(actions.pm.addTask(obj))
		},
		updateTaskGroup: (obj) => {
			dispatch(actions.pm.updateTaskGroup(obj))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DropTarget(PMDNDTypes.WINDOW, dropSource, dropCollect)(PMDesktop))



// WEBPACK FOOTER //
// ./src/components/projectmanager/desktop/PMDesktop.js